module.exports = __webpack_public_path__ + "static/media/Team.768d3a30.psd";